import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { AudioServiceService } from '../audio-service.service';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { LeaderBoardService } from '../leader-board/leaderBoardService.service';
import { TimerService } from '../timer/timerService.service';
import { QuestionsList } from './questions-list';

@Injectable({ providedIn: 'root' })
export class TriviaGameService {
    questionsList = new QuestionsList().questions;
    triviaQuestions = this.questionsList.trivia;
    completeQuestions = this.questionsList.complete;
    easyQuestions = this.triviaQuestions.filter(question => question.difficult == 1);
    mediumQuestions = this.triviaQuestions.filter(question => question.difficult == 2);
    hardQuestions = this.triviaQuestions.filter(question => question.difficult == 3);
    currentQuestion = new Subject<any>();
    randoms = new Subject<number[]>();
    lastLane = 'pink';
    lane = 'pink';
    laneProgress = 1;
    crossroad = new BehaviorSubject('');

    constructor(private gamePlayService: GamePlayService, private leaderBoardService: LeaderBoardService, private audioService: AudioServiceService, private router: Router, private timerService: TimerService) { }

    getRandomQuestion() {
        // this.currentQuestion.next(null);
        this.timerService.stopQuestionTimer();
        this.timerService.startQuestionTimer();
        let random: number;
        // if (this.gamePlayService.level.getValue() % 2 == 0) {
        //     random = this.randomNums(this.completeQuestions.length, 1)[0];
        //     this.currentQuestion.next(this.completeQuestions[random]);
        //     this.completeQuestions.splice(random, 1);
        // } else {
        console.log(this.lane);

        switch (this.lane) {
            case 'pink':
                random = this.randomNums(this.easyQuestions.length, 1)[0];
                this.currentQuestion.next(this.easyQuestions[random]);
                this.easyQuestions.splice(random, 1);
                break;
            case 'green':
                random = this.randomNums(this.mediumQuestions.length, 1)[0];
                this.currentQuestion.next(this.mediumQuestions[random]);
                this.mediumQuestions.splice(random, 1);
                break;
            case 'orange':
                random = this.randomNums(this.hardQuestions.length, 1)[0];
                this.currentQuestion.next(this.hardQuestions[random]);
                this.hardQuestions.splice(random, 1);
                break;
            case 'red':
                random = this.randomNums(this.hardQuestions.length, 1)[0];
                this.currentQuestion.next(this.hardQuestions[random]);
                this.hardQuestions.splice(random, 1);
                break;
            default:
                break;
        }
        this.randoms.next(this.randomNums(4, 4));
        // }
    }

    rightAnswer() {
        let time = this.timerService.seconds.getValue();
        this.timerService.stopQuestionTimer();
        let score = 1000 - (590 - (time * 10));
        if (this.lane == 'green') {
            score = score * 2;
        } else if (this.lane == 'orange') {
            score = score * 3;
        } else if (this.lane == 'red') {
            score = score * 4;
        }
        console.log(score);

        this.gamePlayService.score.next(this.gamePlayService.score.getValue() + score);
        this.gamePlayService.level.next(this.gamePlayService.level.getValue() + 1);
        this.laneProgress += 1;
        this.currentQuestion.next(null);
        setTimeout(() => {
            if (this.lane == 'pink' && this.laneProgress == 5) {
                this.crossroad.next('pink-green');
            } else if (this.lane == 'pink' && this.laneProgress == 6) {
                this.crossroad.next('pink-orange');
            } else if (this.lane == 'green' && this.laneProgress == 4 || this.lane == 'orange' && this.laneProgress == 3) {
                this.crossroad.next('green-orange');
            } else if (this.lane == 'pink' && this.laneProgress == 12 || this.lane == 'green' && this.laneProgress == 7) {
                this.crossroad.next('pink-green-red');
            } else if (this.lane == 'orange' && this.laneProgress == 8) {
                this.crossroad.next('orange-red');
            } else if (this.lane == 'pink' && this.laneProgress == 19) {
                this.lane = 'orange';
                // this.crossroad.next(6);
                this.laneProgress = 12;
                this.getRandomQuestion();
            } else if (this.lane == 'green' && this.laneProgress == 15 || this.lane == 'orange' && this.laneProgress == 15 || this.lane == 'green' && this.laneProgress == 15) {
                //// end game
                this.gameOver();
            } else {
                this.getRandomQuestion();
            }
        }, 3500);
    }

    wrongAnswer() {
        this.gamePlayService.lifes.next(this.gamePlayService.lifes.getValue() - 1);
        if (this.gamePlayService.lifes.getValue() == 0) {
            this.gameOver();
        }
    }

    resetTrivia() {
        this.questionsList = new QuestionsList().questions;
        this.triviaQuestions = this.questionsList.trivia;
        this.completeQuestions = this.questionsList.complete;
        this.easyQuestions = this.triviaQuestions.filter(question => question.difficult == 1);
        this.mediumQuestions = this.triviaQuestions.filter(question => question.difficult == 2);
        this.hardQuestions = this.triviaQuestions.filter(question => question.difficult == 3);
        this.currentQuestion.next(null);

        let pulse = document.getElementById('pulseID');
        if (pulse) {
            pulse.remove();
        }
        this.timerService.pauseTimer();
        this.lane = 'pink';
        this.laneProgress = 1;
        this.crossroad.next('');
    }

    gameOver() {
        this.resetTrivia();
        this.checkScore();
    }

    checkScore() {
        const boardIndex = this.leaderBoardService.boardIndex;
        this.gamePlayService.newPlayer.next(true);

        if (this.leaderBoardService.board[boardIndex].topPlayers.length < 5) {
            this.gamePlayService.addLeaderBoard = true;
        } else {
            const scoreList = this.leaderBoardService.board[boardIndex].topPlayers.map((player) => {
                return player.score;
            });
            const minScore = Math.min(...scoreList);
            if (this.gamePlayService.score.getValue() > minScore) {
                this.gamePlayService.addLeaderBoard = true;
                this.audioService.playAudio('winner');
            } else {
                this.gamePlayService.addLeaderBoard = false;
                this.audioService.playAudio('gameOver');
                // this.gamePlayService.resetGame();
                // this.router.navigate(['choose']);
            }
            // this.gamePlayService.newPlayer.next(true);
        }
    }

    randomNums(length: number, amount: number, bans?: number[]) {
        let randoms = [];
        while (randoms.length < amount) {
            let ban = false;
            let random = Math.floor(Math.random() * length);
            for (let i = 0; i < randoms.length; i++) {
                if (randoms[i] == random) {
                    random = Math.floor(Math.random() * length);
                    i = -1;
                }
            }
            if (bans) {
                for (let j = 0; j < bans.length; j++) {
                    if (bans[j] == random) {
                        ban = true;
                    }
                }
            }
            if (!ban) {
                randoms.push(random);
            }
        }
        return randoms;
    }
}